import { useSelector } from 'react-redux';
import { State } from '../core/reducers';
import { Feature } from '@api/v1';

/**
 * Returns true if the feature is active for the current context.
 * Falls back to state.acl when no authenticated user exists.
 */
export function useActiveFeature(feature: `${Feature}`) {
	const { features: activeFeatures } = useSelector((state: State) => state.auth?.user || state.acl);
	return activeFeatures.includes(feature);
}
